// src/telemetry/constants/routes.ts

import { MODULES } from './modules';

export const TELEMETRY_ROUTES = {

  '/': {
    module: MODULES.DASHBOARD,
    submodule: 'Home',
  },

  '/dashboard': {
    module: MODULES.SEO_MANAGER,
    submodule: 'Strategy Dashboard',
  },

  '/profile': {
    module: MODULES.PROFILE,
    submodule: 'Contact & Identity',
  },

  '/website-builder': {
    module: MODULES.WEBSITE_BUILDER,
    submodule: 'Sitemap',
  },

  '/content-manager': {
    module: MODULES.CONTENT_MANAGER,
    submodule: 'Strategy',
  },

  '/login': {
    module: MODULES.AUTHENTICATION,
    submodule: 'Login',
  },

  '/onboarding': {
    module: MODULES.AUTHENTICATION,
    submodule: 'Onboarding',
  },

  '/marketing-dashboard': {
    module: MODULES.DASHBOARD,
    submodule: 'Marketing Workspaces',
  },

  '/agency-dashboard': {
    module: MODULES.DASHBOARD,
    submodule: 'Agency Dashboard',
  },

  '/gmb-manager': {
    module: MODULES.GMB_MANAGER,
    submodule: 'Overview',
  },

  '/utility-manager': {
    module: MODULES.SEO_MANAGER,
    submodule: 'Utility Manager',
  },

  '/analytics': {
    module: MODULES.ANALYTICS,
    submodule: 'Overview',
  },

  '/reporting': {
    module: MODULES.REPORTING,
    submodule: 'Brand Reports',
  },

//   '/settings': {
//     module: MODULES.SETTINGS,
//     submodule: 'Settings',
//   },

//   '/billing': {
//     module: MODULES.BILLING,
//     submodule: 'Subscription & Billing',
//   },
// 
//   '/subscription': {
//     module: MODULES.BILLING,
//     submodule: 'Subscription Plans',
//   },
// 
//   '/payment/success': {
//     module: MODULES.BILLING,
//     submodule: 'Payment Success',
//   },
// 
//   '/payment/failure': {
//     module: MODULES.BILLING,
//     submodule: 'Payment Failure',
//   },

  '/onboarding/success': {
    module: MODULES.AUTHENTICATION,
    submodule: 'Onboarding Success',
  },

  '/brand-onboarding': {
    module: MODULES.AUTHENTICATION,
    submodule: 'Brand Onboarding',
  },

  '/as-is': {
    module: MODULES.SEO_MANAGER,
    submodule: 'AS-IS State',
  },

} as const;